import { Button } from '../Button';
import { ArrowLeft, ArrowRight } from 'lucide-react';

export default function StepNav({
  onBack,
  onNext,
}: {
  onBack: () => void;
  onNext: () => void;
}) {
  return (
    <div className="flex justify-end gap-6 border-t border-white/8 px-4 pt-4">
      <Button variant="secondary" onClick={onBack}>
        <ArrowLeft size={14} /> Back
      </Button>
      <Button onClick={onNext}>
        Continue <ArrowRight size={14} />
      </Button>
    </div>
  );
}
